



























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Threshold from "../../../store/entities/threshold";
@Component
export default class CreateThreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  threshold: Threshold = new Threshold();
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.thresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "threshold/create",
          data: this.threshold,
        });
        (this.$refs.thresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.thresholdForm as any).resetFields();
    this.$emit("input", false);
  }
  thresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    maxNumber: [{required: true, message: "请填写最大数量", trigger: "blur" }],
    maxtemp: [{ required: true, message: "请填写最大温度", trigger: "blur" }],
    maxhumi: [{required: true, message: "请填写最大湿度", trigger: "blur" }],
    mintemp: [{required: true, message: "请填写最小温度", trigger: "blur" }],
    minhumi: [{required: true, message: "请填写最小湿度", trigger: "blur" }],
  };
}
